import './AgMapBoxStack.scss';
import { LocationIcon } from 'app/agriculture/icons';
import { MapOptionsBox } from 'app/agriculture/AgMapBoxStack/components/MapOptionsBox/MapOptionsBox';
import { BoxStack } from 'app/agriculture/components/BoxStack/BoxStack';

export function AgMapBoxStack() {
    return (
        <div className="AgMapBoxStack" data-testid="AgMapBoxStack">
            <BoxStack>
                <BoxStack.Box
                    id="map-options-stackbox"
                    title="Map Options"
                    icon={<LocationIcon size={16} />}
                >
                    <MapOptionsBox />
                </BoxStack.Box>
            </BoxStack>
        </div>
    );
}
